export default class MuxLoader {
  static loadAndInit({ configs, player_init_time }) {
    if (configs.enabled) {
      const { env_key } = configs;
      const options = this.options({ env_key, player_init_time });
      const script = this.createScript(options);
      this.appendToBody(script);
    }
  }

  static createScript(options) {
    const script = document.createElement('script');
    script.src = 'https://src.litix.io/videojs/3/videojs-mux.js';
    script.async = 'async';
    script.onload = () => {
      this.initMux(options);
    };
    return script;
  }

  static options({ env_key, player_init_time }) {
    return {
      debug: false,
      data: {
        env_key: env_key,
        player_init_time: player_init_time,
        player_name: 'vidio-web',
        video_id: this.data().videoId(),
        video_title: this.data().videoTitle(),
        viewer_user_id: this.data().playUUID(),
        video_stream_type: this.data().type()
      }
    };
  }

  static initMux(options) {
    const mux_interval = window.setInterval(() => {
      if (typeof window.player.tech().plugin !== 'undefined') {
        window.clearInterval(mux_interval);
        this.getPlayerInstance().mux(options);
        this.bindErrorEvent();
      }
    }, 10);
  }

  static bindErrorEvent() {
    this.getPlayerInstance().on('error', this.onErrorCallback.bind(this));
  }

  static onErrorCallback() {
    this.getPlayerInstance().mux.emit('error', {
      player_error_code: this.getPlayerInstance().tech().errorCode(),
      player_error_message: this.getPlayerInstance().tech().errorMessage()
    });
  }

  static data() {
    return window.player.data();
  }

  static getPlayerInstance() {
    return window.player.tech().plugin().instance();
  }

  static appendToBody(element) {
    document.body.appendChild(element);
  }
}
